var map = {
	"./CompactHeader.tsx": 664,
	"./Footer.tsx": 40596,
	"./Header.tsx": 39051,
	"./HomePage.tsx": 80466,
	"./Layout.tsx": 80437,
	"./SharedContent.tsx": 4253,
	"./SignInPage.tsx": 25860,
	"./UnhandledErrorModal.tsx": 89630,
	"./VariantRootPage.tsx": 96477
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 62141;